module.exports = __webpack_public_path__ + "img/fullscreen-icon.a866e5f2.svg";